import { render, staticRenderFns } from "./ManagerBookingGuests.vue?vue&type=template&id=5a2712a3&"
import script from "./ManagerBookingGuests.vue?vue&type=script&lang=js&"
export * from "./ManagerBookingGuests.vue?vue&type=script&lang=js&"
import style0 from "./ManagerBookingGuests.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports